module.exports = __webpack_public_path__ + "static/fonts/342F4F_11_0.72eda73.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_11_0.ttf
// module id = 106
// module chunks = 3